import BaseApi from './BaseApi'

export default class Product extends BaseApi {
    get(id, expand, options = {}) {
        return this.axios.get('/product/product/' + id, {params: {expand}, ...options})
    }

    file(id, options = {}) {
        return this.axios.get('/product/file/' + id, options)
    }

    createFile(id, type, options = {}) {
        return this.axios.post('/product/file', {product_id: id, type: type}, options)
    }

    downloadFile(id) {
        return this.axios.get('/product/file/download/' + id, {responseType: 'blob'})
    }

    stock(product_id, expand, options = {}) {
        return this.getData('stock', product_id, expand, options)
    }

    video(product_id, expand, options = {}) {
        return this.getData('video', product_id, expand, options)
    }

    commonAnalog(product_id, expand = {}, options = {}) {
        return this.getData('analog/common', product_id, expand, options)
    }

    kitAnalog(product_id, expand = {}, options = {}) {
        return this.getData('analog/kit', product_id, expand, options)
    }

    related(product_id, type, options = {}) {
        let params = {
            'product_id': product_id,
            'type': type
        }
        return this.axios.get('/product/related', {params: params, ...options})
    }

    hierarchy(product_id, expand, options = {}) {
        return this.getData('hierarchy', product_id, expand, options)
    }

    certificate(product_id, expand, options = {}) {
        return this.getData('certificate', product_id, expand, options)
    }

    media(product_id, expand, options = {}) {
        return this.getData('media', product_id, expand, options)
    }

    etim(product_id, expand, options = {}) {
        return this.getData('etim', product_id, expand, options)
    }

    characteristic(product_id, expand, options = {}) {
        return this.getData('characteristic', product_id, expand, options)
    }

    packingNetto(product_id, expand, options = {}) {
        return this.getData('packing/netto', product_id, expand, options)
    }

    packingGross(product_id, expand, options = {}) {
        return this.getData('packing/gross', product_id, expand, options)
    }

    getData(method, product_id, expand, options = {}) {
        let params = {
            'product_id': product_id,
        }
        if (expand) {
            params = Object.assign({}, params, {'expand': expand})
        }

        return this.axios.get('/product/' + method, {params: params, ...options})
    }
}